import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt24 } from './phonics/phonics_data_lt24';

function PhonicsLt24() {
  return <PhonicsLt letterData={letterDataLt24} />;
}

export default PhonicsLt24;
